var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',[_c('doughnut',{staticStyle:{"width":"350px","height":"350px"},attrs:{"chart-data":_vm.datacollection,"options":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }